// extracted by mini-css-extract-plugin
export default {"productGallery":"zM-z","inQuickShop":"AM-z"};